/**
 * Concept Archetype
 *
 * @Version 1.0
 * @Author Daniel Lepe
 */

import Axios from 'axios';
import _ from 'lodash'
import { notify } from '@/utils.js'
import moment from 'moment';

const baseController = 'easylunch'

const baseIndex = baseController + '/index'

const selectFilters = {
    editMode: false,
    cede_id: null,
    tipo: null,
    weeknumber: 0,
    filtering: true,
    fechas: {
        inicio: moment().format('YYYY-MM-DD'),
        fin: moment().add(4, 'day').format('YYYY-MM-DD')
    }
}

const archetype = [
    // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        type: 'hidden'
    },

];

const captions = [
    // {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    return str;
}

let getLunchAgenda = async (filters) => {
    try {
        let response = await Axios.post(baseController + '/getlunch', filters)
        if (typeof response != 'object')
            throw 'Error al consultar la agenda';
        return response
    } catch (e) {
        notify(e)
    }
}

let loadupPreFilters = async () => {
    try {
        let response = await Axios.get(baseController + '/prefilters')
        if (typeof response != 'object')
            throw 'Error al consultar los prefiltros';
        return response
    } catch (e) {
        notify(e)
    }
}
let toggleDateInLunchbox = async ({date, presenciaId}) => {
    try {
        let response = await Axios.post(baseController + '/toggledate', {date, presenciaId})
        if (!_.isObjectLike( response )){
            console.log("!isObjectLike", response)
            throw 'Error al actualizar la presencia';
        }
        return response
    } catch (e) {
        notify(e)
    }
}

let agendaArchetype = {
    headers: [],
    groups: [],
    alumnos: [],
    agendaordenes: [],
}

let getWeekConfigDates = (inputDate) => {


    // Define function to get date of this week's Monday
    function getMonday(inputDate) {
        // Get current date using moment.js
        const currentDate = moment(inputDate, 'YYYY-MM-DD');

        // Get current day of the week (0-6)
        const currentDayOfWeek = currentDate.day();

        // Calculate the number of days to add or subtract to get to Monday
        const daysToMonday = currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;

        // Calculate the date of this week's Monday
        const mondayDate = currentDate.clone().subtract(daysToMonday, 'days');

        // Return the date of this week's Monday in the desired format
        return mondayDate.format('YYYY-MM-DD');
    }

    // Define function to find Friday date and week number from a given date
    function findFridayDateAndWeekNumber(date) {
        // Use Moment.js to create a new date object from the input date string
        const inputDate = moment(date, 'YYYY-MM-DD');

        // Use Moment.js to find the date of the previous Friday
        const fridayDate = inputDate.clone().startOf('week').add(4, 'days');

        // Use Moment.js to find the week number of the previous Friday
        const weekNumber = fridayDate.week();

        // Return the Friday date and week number as an object
        return {
            fridayDate: fridayDate.format('YYYY-MM-DD'),
            weekNumber: weekNumber,
        };
    }

    // Define function to find the Monday date for the week preceding a given date
    function findMondayDateForPreviousWeek(date) {
        // Use Moment.js to create a new date object from the input date string
        const inputDate = moment(date, 'YYYY-MM-DD');

        // Use Moment.js to subtract one week from the input date
        const previousWeek = inputDate.clone().subtract(1, 'week');

        // Use Moment.js to find the date of the Monday for the previous week
        const mondayDate = previousWeek.clone().startOf('week');

        // Return the Monday date as a string in the desired format
        return mondayDate.format('YYYY-MM-DD');
    }

    // Define function to find the next Monday date from a given date
    function findNextMondayDate(date) {
        // Use Moment.js to create a new date object from the input date string
        const inputDate = moment(date, 'YYYY-MM-DD');

        // Use Moment.js to add one week to the input date
        const nextWeek = inputDate.clone().add(1, 'week');

        // Use Moment.js to find the date of the Monday for the next week
        const mondayDate = nextWeek.clone().startOf('week');

        // Return the Monday date as a string in the desired format
        return mondayDate.format('YYYY-MM-DD');
    }

    // Example usage
    inputDate = inputDate || moment().format('YYYY-MM-DD');

    const result = findFridayDateAndWeekNumber(inputDate);

    const mondayDatePast = findMondayDateForPreviousWeek(inputDate);

    const nextMondayDate = findNextMondayDate(inputDate);

    const mondayDate = getMonday(inputDate);

    const returning = {
        weekNumber: result.weekNumber,
        fridayDate: result.fridayDate,
        mondayDate,
        mondayDatePast,
        nextMondayDate
    }

    console.log(`Week number: ${result.weekNumber}`);
    console.log(`Friday date: ${result.fridayDate}`);
    console.log(`Monday date: ${mondayDate}`);
    console.log(`Monday past week: ${mondayDatePast}`);
    console.log(`Monday next week: ${nextMondayDate}`);

    return returning;
}

export {
    // CONST
    archetype,
    captions,
    baseIndex,
    selectFilters,
    agendaArchetype,

    // FUNCTIONS
    loadupPreFilters,
    getLunchAgenda,
    automodalHandler,
    getWeekConfigDates,
    toggleDateInLunchbox

}
